module.exports = __webpack_public_path__ + "media/images/pages/contact-d3532f44454ae1823b50ca9156236a53.jpg";